if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      if (!activeMedia) return;
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  });
}

/* ===== TrueToe: downpage CTA -> scroll to offer + select best-value bundle =====
   The theme sets a global CSS scroll-behavior:smooth which cancels programmatic
   scrolls, so this animates scrollTop manually with behavior forced to auto.
   Inert on any page without a Kaching bundle block. Remove to revert. */
(function () {
  var OFFSET = 110;
  var DURATION = 600;

  function offerRoot() {
    return document.querySelector('[id^="shopify-block"][id$="__kaching"]');
  }

  function scrollToY(targetY, done) {
    var el = document.scrollingElement || document.documentElement;
    var prev = el.style.scrollBehavior;
    el.style.scrollBehavior = 'auto';
    var startY = el.scrollTop;
    var dist = targetY - startY;
    var t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / DURATION);
      var e = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;
      el.scrollTop = startY + dist * e;
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        finish();
      }
    }
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      el.scrollTop = targetY;
      el.style.scrollBehavior = prev;
      if (done) done();
    }
    requestAnimationFrame(step);
    setTimeout(finish, DURATION + 200);
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    var btn = t.closest('button[name="add"]');
    if (!btn) return;
    if (btn.closest('[id^="shopify-section"][id$="__main"]')) return;

    var root = offerRoot();
    if (!root) return;

    ev.preventDefault();
    ev.stopImmediatePropagation();

    var el = document.scrollingElement || document.documentElement;
    var y = root.getBoundingClientRect().top + el.scrollTop - OFFSET;

    scrollToY(y < 0 ? 0 : y, function () {
      var best = root.querySelector('.kaching-bundles__bars .kaching-bundles__bar input[type="radio"]');
      if (best && !best.checked) best.click();
    });
  }, true);
})();
